import { ConferenceTypeEnum, EcosystemEnum, ZoomAccount } from "@clockwise/schema";
import { MeetLogo } from "@clockwise/web-commons/src/components/svgs/MeetLogo";
import { TeamsLogo } from "@clockwise/web-commons/src/components/svgs/TeamsLogo";
import { ZoomLogo } from "@clockwise/web-commons/src/components/svgs/ZoomLogo";
import { routeToFeature } from "@clockwise/web-commons/src/util/routes.util";
import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";
import React, { useCallback } from "react";

interface Props {
  onChange: (conferenceType: ConferenceTypeEnum | null) => void;
  zoomAccount?: ZoomAccount;
  zoomUserLevelAccount?: ZoomAccount;
  conferenceType: ConferenceTypeEnum | null;
  ecosystem: EcosystemEnum;
}

const NONE = "None" as const;
const CONNECT_ZOOM = "ConnectZoom" as const;

export const EventSchedulerVideoConferencingInput = ({
  zoomAccount,
  zoomUserLevelAccount,
  ecosystem,
  conferenceType,
  onChange,
}: Props) => {
  const onChangeType = useCallback(
    (e: React.ChangeEvent<HTMLSelectElement>) => {
      const type = e.target.value as ConferenceTypeEnum | typeof NONE | typeof CONNECT_ZOOM;
      if (type === NONE) {
        onChange(null);
        return;
      }
      if (type === CONNECT_ZOOM) {
        routeToFeature({
          featureName: "appSettings",
          routerState: { kind: "window", target: "_blank" },
          options: {
            paramsObj: { highlight: "true" },
            hash: "#zoom",
            relative: true,
          },
        });
        return;
      }
      onChange(type);
    },
    [onChange],
  );

  // check if this user has a valid account on the organization's connected zoom account
  const canUseZoom = zoomUserLevelAccount || (zoomAccount && zoomAccount.hasValidZoomAccount);

  return (
    <div className="cw-py-3">
      <div className="cw-flex cw-items-center cw-py-3">
        <FormControl fullWidth>
          <InputLabel shrink htmlFor="cw-video-conferencing">
            Video conferencing
          </InputLabel>
          {/* FIXME: (skopec) use DS component */}
          <Select
            value={conferenceType || NONE}
            onChange={onChangeType}
            name="Video Conferencing"
            inputProps={{
              name: "Video Conferencing",
              id: "cw-video-conferencing",
            }}
            fullWidth
          >
            {canUseZoom ? (
              <MenuItem value={ConferenceTypeEnum.Zoom}>
                <div className="cw-flex cw-items-center cw-gap-2">
                  <ZoomLogo />
                  <span>Zoom</span>
                </div>
              </MenuItem>
            ) : (
              <MenuItem value={CONNECT_ZOOM}>
                <div className="cw-flex cw-items-center cw-gap-2">
                  <ZoomLogo />
                  <span>Connect Zoom Account</span>
                </div>
              </MenuItem>
            )}
            {ecosystem === "Microsoft" ? (
              <MenuItem value={ConferenceTypeEnum.TeamsForBusiness}>
                <div className="cw-flex cw-items-center cw-gap-2">
                  <TeamsLogo />
                  <span>Microsoft Teams</span>
                </div>
              </MenuItem>
            ) : (
              <MenuItem value={ConferenceTypeEnum.Meet}>
                <div className="cw-flex cw-items-center cw-gap-2">
                  <MeetLogo />
                  <span>Google Meet</span>
                </div>
              </MenuItem>
            )}
            <MenuItem value={NONE} className="cw-flex cw-items-center cw-gap-1">
              No video conferencing
            </MenuItem>
          </Select>
        </FormControl>
      </div>
    </div>
  );
};
